import { DateObject } from 'tabs/topQuestions/utils/DateUtils'
import {
  CLUSTERING_UPDATE_IS_TRAINING,
  ClusteringStatus,
  ClusteringUpdateIsTraining,
  LINE_CHART_FILTER_END_DATE_CHANGE,
  LINE_CHART_FILTER_START_DATE_CHANGE,
  LineChartFilterEndDateChange,
  LineChartFilterStartDateChange,
  UpdateClusteringIsTraining,
} from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusTypes'
import { ClusteringCheckStatus } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusSlice'
import { UpdateClusteringStatusPayload } from 'tabs/topQuestions/types/InternalTypes'

export const lineChartFilterStartDateChange = (startDate: DateObject): LineChartFilterStartDateChange => ({
  type: LINE_CHART_FILTER_START_DATE_CHANGE,
  payload: startDate,
})
export const lineChartFilterEndDateChange = (endDate: DateObject): LineChartFilterEndDateChange => ({
  type: LINE_CHART_FILTER_END_DATE_CHANGE,
  payload: endDate,
})

export const updateIsTraining = (clusteringId: string, status: ClusteringStatus): ClusteringUpdateIsTraining => ({
  type: CLUSTERING_UPDATE_IS_TRAINING,
  payload: {
    status, clusteringId,
  },
})

export const updateClusteringStatus = (payload: UpdateClusteringStatusPayload): ClusteringUpdateIsTraining => ({
  type: CLUSTERING_UPDATE_IS_TRAINING,
  payload: {
    clusteringId: payload.clusteringExecutionId,
    status: payload.status
  },
})

export function updateTrainingStatus(trainingClusters: Record<string, ClusteringCheckStatus>,
                                     { status, clusteringId }: UpdateClusteringIsTraining) {
  const existingStatus = trainingClusters[clusteringId]
  const n = existingStatus != undefined ? (existingStatus.n + 1) : 0
  trainingClusters[clusteringId] = { status, n }
  return { ...trainingClusters }
}
